import React from "react";

interface Props {
  children?: JSX.Element;
}

export const PageAsideLeftWrapper = ({ children }: Props) => {
  return <div className="main-aside">{children}</div>;
};
